import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { environment } from "../environments/environment";
import { Rekbot } from '../models/rekbot.model';


@Injectable({
  providedIn: 'root'
})
export class UserRekbotService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router

  ) { }

  getUserRekbots(userId: number) {
    const endpoint = environment.apiUrl + "/api/users/" + userId + "/getUserRekbots";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()

    return this.http.get(
      endpoint,
      {
        headers: new HttpHeaders().set("Authorization", bearerToken)
      });
  }

  saveUserRekbots(userId: number, userRekbots: Rekbot[]) {
    const endpoint = environment.apiUrl + "/api/users/" + userId + "/saveUserRekbots"  ;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken()

    return this.http.put(
      endpoint,
      {
        'userRekbots' : userRekbots
      },
      {
        headers: new HttpHeaders().set("Authorization", bearerToken)
      });

  }

}
